import { BagSdkMethod } from "../utils/method-initialiser";

type PublicCheckoutRedirectMethod = (params?: { storeUrl?: string }) => void;
type CheckoutRedirectMethod = BagSdkMethod<PublicCheckoutRedirectMethod>;

const createCheckoutUrlFallback = (countryCode: string) => {
  const { protocol, host } = window.location;
  const secureHost = host.replace(/^www\./, "secure.");
  return `${protocol}//${secureHost}/${countryCode.toLowerCase()}`;
};

export const initialiseCheckoutInitialiser: CheckoutRedirectMethod =
  (context) =>
  (params = {}) => {
    const { storeUrl } = params;
    const checkoutStoreUrl =
      storeUrl || createCheckoutUrlFallback(context.country);

    window.location.href = `${checkoutStoreUrl}/initialise`;
  };
